










































































































































import { Component, Vue } from "vue-property-decorator";
import {
  ProdutosService,
  FiltrosProdutos,
  Produto,
} from "@/services/produtos.service";
import Tooltip from "@/shared/components/tooltip.vue";
import DataTable from "@/shared/components/data-table.vue";
import TreeSelectCategorias from "@/shared/components/tree-select-categorias.vue";
import ImagemAvatar from "@/shared/components/imagem-avatar.vue";
import ImagePreview from "@/shared/components/image-preview.vue";
import HistoricoProduto from "./historico/HistoricoProduto.vue";
import { CatalogosService } from "@/services/catalogos.service";
import { moeda, dateTime } from "@/shared/filters";
@Component({
  components: {
    Tooltip,
    TreeSelectCategorias,
    HistoricoProduto,
    ImagemAvatar,
    ImagePreview,
    DataTable,
  },
  filters: { moeda, dateTime },
})
export default class Produtos extends Vue {
  loading = false;
  promise: Promise<Produto[]> | null = null;
  filters: FiltrosProdutos = {
    idCatalogo: "",
    nome: "",
    descricao: "",
    codigoFornecedor: "",
    idCategoria: null,
    ativos: true,
    sImagens: false,
    soKit: false,
  };
  headers = [
    { value: "imagensProduto", text: "Imagem", sortable: false },
    { value: "descricao", text: "Produto" },
    { value: "codigoFornecedor", text: "Codigo Fornecedor" },
    { value: "categoria.nome", text: "Categoria" },
    { value: "valorVenda", text: "Valor Venda" },
    { value: "validoApos", text: "Válido Após" },
    { value: "excluido", text: "Excluido" },
    { value: "ehKit", text: "Kit" },
    { value: "actions", text: "Ações", sortable: false },
  ];

  async mounted() {
    this.filters.idCatalogo = this.$route.params.idCatalogo;
    const catalogo = await CatalogosService.obterCatalogo(
      this.filters.idCatalogo
    );
    if (catalogo) {
      this.filters.nome = catalogo.nome;
    }
    this.fetchProdutos();
  }
  async fetchProdutos() {
    this.promise = ProdutosService.listarProdutosDoCatalogo(this.filters);
  }
  async editarItemSemHistorico(item: Produto) {
    if (item.idProduto) {
      this.$router.push({
        name: "catalogos-produtos-alterar",
        params: { id: item.idProduto },
      });
    }
  }

  visualizar(url: string) {
    const imagem = this.$refs.imagem as ImagePreview;
    imagem.abrir(url);
  }
}
